import { useState, useEffect } from "react";
import { Toast } from "src/components";

export const useImageUpload = (updateNestedField, getErrorMessage, setFormErrors, formErrors) => {
    const [formSubmitLoading, setFormSubmitLoading] = useState(false);
    const [quoteImage, setQuoteImage] = useState(null);
    const [articleImage, setArticleImage] = useState(null);
    const [imageToCrop, setImageToCrop] = useState(null);
    const [quoteCroppedBlob, setQuoteCroppedBlob] = useState(null);
    const [articleCroppedBlob, setArticleCroppedBlob] = useState(null);
    const [showCropperModal, setShowCropperModal] = useState(false);

    const handleCropComplete = (file, type) => {
        if (!file) return;
        const url = URL.createObjectURL(file);
        if (type === "quote") {
            if (quoteImage) URL.revokeObjectURL(quoteImage);
            updateNestedField("objectImage", "quotes", url);
            setQuoteImage(url);
            setQuoteCroppedBlob(file);
        } else if (type === "article") {
            if (articleImage && typeof articleImage === "string") URL.revokeObjectURL(articleImage);
            updateNestedField("objectImage", "article", url);
            setArticleImage(url);
            setArticleCroppedBlob(file);
        }

        setShowCropperModal(false);
    };
    
    const cropImages = { 
        imageToCrop, 
        quoteCroppedBlob,
        articleCroppedBlob,
        showCropperModal, 
        handleCropComplete,
        setShowCropperModal,
        setImageToCrop
    };
    
    const handleImageUpload = (acceptedFiles, imageType) => {
        if (!acceptedFiles || acceptedFiles.length === 0) return;
        const file = acceptedFiles[0];
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
            Toast.error("Unsupported file type. Images may be JPEG or PNG format.");
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            switch (imageType) {
                case "quoteImage":
                    setQuoteImage(result);
                    updateNestedField("objectImage", "quotes", result);
                    setImageToCrop({ src: result, type: "quote" });
                    setShowCropperModal(true);
                    if (file && getErrorMessage(formErrors, "imageUrl")) {
                        setFormErrors((prev) => prev.filter(err => err.input !== "imageUrl"));
                        setFormErrors((prev) => prev.filter(err => err.input !== "thumbnailUrl"));
                    }
                    break;
                case "articleImage":
                    setArticleImage(result);
                    updateNestedField("objectImage", "article", result);
                    setImageToCrop({ src: result, type: "article" });
                    setShowCropperModal(true);
                    if (file && getErrorMessage(formErrors, "articleImageUrl")) {
                        setFormErrors((prev) => prev.filter(err => err.input !== "articleImageUrl"));
                    }
                    break;
                default:
                    console.warn("Unknown image type:", imageType);
            }
        };
        reader.readAsDataURL(file);
    };

    useEffect(() => {
        return () => {
            if (quoteImage) URL.revokeObjectURL(quoteImage);
            if (articleImage && typeof articleImage === "string") URL.revokeObjectURL(articleImage);
        };
    }, [quoteImage, articleImage]);

    return {
        formSubmitLoading,
        setFormSubmitLoading,
        setQuoteImage,
        quoteImage,
        setArticleImage,
        articleImage,
        handleAddQuoteImage: (files) => handleImageUpload(files, "quoteImage"),
        handleAddArticleImage: (files) => handleImageUpload(files, "articleImage"),
        cropImages,
    };
};
